import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=c1a87b5c&scoped=true"
import script from "./ArticleListItem.vue?vue&type=script&lang=js"
export * from "./ArticleListItem.vue?vue&type=script&lang=js"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=c1a87b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a87b5c",
  null
  
)

export default component.exports